import { render, staticRenderFns } from "./FootPrint.vue?vue&type=template&id=23589aa4&scoped=true"
import script from "./FootPrint.vue?vue&type=script&lang=js"
export * from "./FootPrint.vue?vue&type=script&lang=js"
import style0 from "./FootPrint.vue?vue&type=style&index=0&id=23589aa4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23589aa4",
  null
  
)

export default component.exports